import React, { useState,useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { confirmDialog } from "primereact/confirmdialog";
import { toast } from "react-toastify";
import { Dropdown } from "primereact/dropdown";

import { capitalize } from "../../../services/utility/helper";
import { leaveService } from "../../../services/extensions";
import { LeaveStatus } from "../../../common/util/constants";
import { utitService } from "../../../services/util";
import { selectData } from "../../../services/store/userSlice";
import { Util } from "../../../services";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { ViewLeave } from "./view-leave";
import DateColumn from "../components/DateColumn";

const Reject = ({ leaves, reload }) => {
  const userData = useSelector(selectData);
  const { user } = useSelector((state) => state.user);
  const [selectedLeaves, setSelectedLeaves] = useState(null);
  const [editingRows, setEditingRows] = useState({});
  const [selLeaves, setSelLeaves] = useState({});
  const [viewDialog, setViewDialog] = useState(false);
  const [viewTabIndex, setViewTabIndex] = useState(0);
  const [region, setRegion] = useState("ESIN");

  useEffect(() => {
    if (user) {
      const leCode = user?.LegalEntity?.code || "ESIN";
      setRegion(leCode);
    }
  }, [user]);

  const recallLeave = (e) => {
    // console.log("Editing row", editingRows);
  };

  const viewLeave = (row, tabIndex = 0) => {
    setSelLeaves(row);
    setViewDialog(true);
    setViewTabIndex(tabIndex);
  };

  const renderActions = (rowData, options) => {
    return (
      <div>
        {rowData.attachment !== null && (
          <Button
            icon="pi pi-link"
            className="p-button-rounded p-button-text p-button-warning"
            aria-label="Document"
            onClick={() => viewLeave(rowData, 1)}
          />
        )}
        <Button
          icon="pi pi-eye"
          className="p-button-rounded p-button-text"
          aria-label="Edit"
          onClick={() => viewLeave(rowData)}
        />
        {/* <Button icon="pi pi-replay" tooltip='Recall' tooltipOptions={{ position: 'top' }} className="p-button-rounded p-button-text p-button-danger" aria-label="Recall" onClick={(e) => recallLeave(e, rowData)} /> */}
      </div>
    );
  };
  const renderLeaveHours = (rowData) => {
    if (!rowData.leaveHours || rowData.leaveHours <= 0) return "-";
    return <strong>{rowData.leaveHours}</strong>;
  };
  const renderAbsenceCode = (rowData, options) => {
    return (
      <>
        <strong>{rowData.absenceCode}</strong>
        {userData.absenceCode && (
          <em> ({userData?.absenceCode[rowData.absenceCode]?.title})</em>
        )}
      </>
    );
  };
  const renderAbsenceDuration = (rowData, options) => {
    return (
      <>
        <strong>{rowData.leaveType}</strong>
        {userData.leaveCode && (
          <em> ({userData?.leaveCode[rowData.leaveType]?.title})</em>
        )}
      </>
    );
  };
  const renderReasonOfLeave = (rowData, options) => {
    const reason = rowData[options.field] || "";
    const txt = reason.substr(0, 200);
    return (
      <>
        <span className="noet">{txt}</span>
      </>
    );
  };

  const submitLeaves = () => {
    const leaveIds = selectedLeaves?.map((leave) => leave.id) || [];
    const currentUser = JSON.parse(localStorage.getItem("user"));
    if (leaveIds.length > 0) {
      let payload = { Ids: leaveIds };
      leaveService.updateMultipleLeave(payload).then((resp) => {
        toast.success(
          "Your leaves have been shared with " +
            capitalize(currentUser.superior.firstName) +
            " " +
            capitalize(currentUser.superior.lastName) +
            " for approval",
        );
        setSelectedLeaves([]);
        reload();
      });
    }
  };

  return (
    <div>
      <DataTable
        value={leaves}
        responsiveLayout="scroll"
        paginator
        rows={10}
        rowsPerPageOptions={[5, 10, 25, 50]}
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        selection={selectedLeaves}
        onSelectionChange={(e) => setSelectedLeaves(e.value)}
        selectionMode="multiple"
        editMode="row"
        editingRows={editingRows}
        dataKey="id"
      >
        <Column selectionMode="multiple" headerStyle={{ width: "3rem" }} />
        <Column
          field="startDate"
          header="Start Date"
          headerStyle={{ width: "130px" }}
          body={DateColumn}
        />
        <Column
          field="endDate"
          header="End Date"
          headerStyle={{ width: "130px" }}
          body={DateColumn}
        />
        {/* <Column header="Day" headerStyle={{ width: '100px' }} body={(rowData) => (utitService.dateParser(rowData.startDate, 'dddd'))} /> */}
        {region === "ESAU" && (
          <Column
            field="leaveHours"
            header="Hours"
            headerStyle={{ width: "100px" }}
            body={renderLeaveHours}
          />
        )}
        <Column
          field="absenceCode"
          header="Absence Code"
          headerStyle={{ width: "220px" }}
          body={renderAbsenceCode}
        />
        <Column
          field="leaveType"
          header="Leave Type"
          headerStyle={{ width: "180px" }}
          body={renderAbsenceDuration}
        />
        <Column
          field="reasonOfLeave"
          header="Reason of Leave"
          body={renderReasonOfLeave}
        />
        <Column
          field="reason"
          header="Reason of Rejection"
          body={renderReasonOfLeave}
        />
        <Column
          header="Actions"
          headerStyle={{ width: "90px", textAlign: "center" }}
          bodyStyle={{ textAlign: "right" }}
          body={renderActions}
        />
      </DataTable>
      {ViewLeave({
        visible: viewDialog,
        onHide: () => setViewDialog(false),
        style: { width: "900px" },
        leave: selLeaves,
        header: "Leave Details",
        tabIndex: viewTabIndex,
      })}
    </div>
  );
};
export default Reject;
